export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NON_BINARY = 'NON_BINARY',
}

export enum CompanyType {
  B2B = 'B2B',
  B2C = 'B2C',
  NGO = 'NGO',
  Educational = 'Educational',
  Independant = 'Independant',
  Public = 'Public',
  Gouvernment = 'Gouvernment',
}

export enum HierarchicalLevel {
  FOUNDER = 'founder',
  CXO = 'CxO',
  DECISION_MAKER = 'decision_maker',
  MANAGER = 'manager',
  EMPLOYEE = 'employee',
}

export enum Devices {
  ANDROID_SMART_PHONE = 'ANDROID_SMART_PHONE',
  IOS_SMART_PHONE = 'IOS_SMART_PHONE',

  ANDROID_TABLET = 'ANDROID_TABLET',
  IOS_TABLET = 'IOS_TABLET',

  ANDROID_SMART_WATCH = 'ANDROID_SMART_WATCH',
  IOS_SMART_WATCH = 'IOS_SMART_WATCH',

  MAC_OS_COMPUTER = 'MAC_OS_COMPUTER',
  WINDOWS_COMPUTER = 'WINDOWS_COMPUTER',
  LINUX_COMPUTER = 'LINUX_COMPUTER',
}

export enum EducationLevel {
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  ALUM = 'ALUM',
  PROFESSIONAL_DEGREE = 'PROFESSIONAL_DEGREE',
  ASSOCIATE_DEGREE = 'ASSOCIATE_DEGREE',
  HIGH_SCHOOL_GRAD = 'HIGH_SCHOOL_GRAD',
  MASTER_DEGREE = 'MASTER_DEGREE',
  DOCTORATE_DEGREE = 'DOCTORATE_DEGREE',
}

export enum FamilyStatus {
  SINGLE_NO_CHILDREN = 'SINGLE_NO_CHILDREN',
  COUPLE_NO_CHILDREN = 'COUPLE_NO_CHILDREN',
  SINGLE_WITH_CHILDREN = 'SINGLE_WITH_CHILDREN',
  COUPLE_WITH_CHILDREN = 'COUPLE_WITH_CHILDREN',
}

export enum Income {
  D0_D3 = 'D0_D3', // 1500
  D3_D5 = 'D3_D5', // 1800
  D5_D7 = 'D5_D7', // 2300
  D7_D8 = 'D7_D8', // 2800
  D8_D9 = 'D8_D9', // 3500
  C90_C95 = 'C90_C95', // 4300
  C95_C98 = 'C95_C98', // 7000
  C98P = 'C98P', // > 7000

  D3_D7 = 'D3_D7',
  D8_C95 = 'D8_C95',
  C95P = 'C95P',
}

export enum TechSavviness {
  LOW = 'LOW',
  AVERAGE = 'AVERAGE',
  ADVANCED = 'ADVANCED',
}

export enum Industry {
  AGRICULTURE_FARMING_RANCHING = 'AGRICULTURE_FARMING_RANCHING',
  AGRIFOOD_FOOD_INDUSTRY = 'AGRIFOOD_FOOD_INDUSTRY',
  ARCHITECTURE_INTERIORDESIGN = 'ARCHITECTURE_INTERIORDESIGN',
  CONSTRUCTION_BTP = 'CONSTRUCTION_BTP',
  REAL_ESTATE = 'REAL_ESTATE',
  ENERGY = 'ENERGY',
  INDUSTRY_MANUFACTURING = 'INDUSTRY_MANUFACTURING',
  GOODSTRANSPORT_LOGISTICS = 'GOODSTRANSPORT_LOGISTICS',
  DISTRIBUTION_MASSRETAILING = 'DISTRIBUTION_MASSRETAILING',
  RETAIL_SMALLSCALERETAILING = 'RETAIL_SMALLSCALERETAILING',
  ECOMMERCE_MARKETPLACE_ONLINERETAIL = 'ECOMMERCE_MARKETPLACE_ONLINERETAIL',
  MOBILITY_TRANSPORTATION = 'MOBILITY_TRANSPORTATION',
  TOURISM_HOSPITALITY = 'TOURISM_HOSPITALITY',
  RESTAURANT_FOODANDBAVERAGESRETAIL = 'RESTAURANT_FOODANDBAVERAGESRETAIL',
  CULTURE_MEDIA_PRESS_ENTERTAINMENT_LEISURE = 'CULTURE_MEDIA_PRESS_ENTERTAINMENT_LEISURE',
  FASHION_LUXURY_BEAUTY_LIFESTYLE = 'FASHION_LUXURY_BEAUTY_LIFESTYLE',
  HEALTH_MEDICAL_SERVICES_PHARMACEUTICAL = 'HEALTH_MEDICAL_SERVICES_PHARMACEUTICAL',
  SOCIAL_ENVIRONMENTAL_PERSONALSERVICES = 'SOCIAL_ENVIRONMENTAL_PERSONALSERVICES',
  BANKING_INSURANCE_FINANCE = 'BANKING_INSURANCE_FINANCE',
  CONSULTING_AUDIT = 'CONSULTING_AUDIT',
  MARKETING_COMMUNICATION_ADVERTISING_DESIGN = 'MARKETING_COMMUNICATION_ADVERTISING_DESIGN',
  LEGAL_ACCOUNTING_MANAGEMENT = 'LEGAL_ACCOUNTING_MANAGEMENT',
  RECRUITMENT_HR = 'RECRUITMENT_HR',
  EDUCATION_TRAINING = 'EDUCATION_TRAINING',
  TECH_DIGITAL = 'TECH_DIGITAL',
  PUBLIC_ADMINISTRATION = 'PUBLIC_ADMINISTRATION',
  ASSOCIATION_NGO = 'ASSOCIATION_NGO',
}

export enum CompanySize {
  SIZE_0 = 'SIZE_0',
  SIZE_1 = 'SIZE_1',
  SIZE_2 = 'SIZE_2',
  SIZE_3 = 'SIZE_3',
  SIZE_4 = 'SIZE_4',
  SIZE_5 = 'SIZE_5',
  SIZE_6 = 'SIZE_6',
  SIZE_7 = 'SIZE_7',
  SIZE_8 = 'SIZE_8',
}

export enum ProfessionalSituation {
  WORKING = 'WORKING',
  STUDENT = 'STUDENT',
  LOOKING_FOR_JOB = 'LOOKING_FOR_JOB',
  UNEMPLOYED = 'UNEMPLOYED',
  RETIRED = 'RETIRED',
}
